<div class="funeral-how-it-works">
	<div class="container container-mobile">
		<h2>How It Works</h2>

		<div class="funeral-how-header">
			<div class="funeral-how-title">
				<span class="funeral-how-title-main">Creating a Catholic Funeral Plan</span>
				<span class="funeral-how-title-accent">Made Simple</span>
			</div>

			<p class="funeral-how-intro">
				Three easy steps to document your wishes, honor your faith, and bring peace of mind around your funeral planning journey.
			</p>
		</div>

		<div class="funeral-how-steps">
			@for (step of steps; track step.number; let i = $index) {
				@if (i > 0) {
					<div class="funeral-how-arrow" aria-hidden="true">
						<span>&rsaquo;</span>
					</div>
				}

				<div class="funeral-how-card">
					<div class="funeral-how-step-number">{{ step.number }}</div>
					<div class="funeral-how-icon-wrap">
						<img [src]="step.iconSrc" [alt]="step.iconAlt" class="funeral-how-icon" />
					</div>
					<h3 class="funeral-how-card-title">{{ step.title }}</h3>
					<p class="funeral-how-card-text" [innerHTML]="step.description"></p>
				</div>
			}
		</div>

		<div class="funeral-how-cta">
			<button type="button" class="btn btn-primary btn-block action-btn" (click)="onCtaClick()">
				Create Your Free Funeral Plan
			</button>
		</div>
	</div>
</div>
